<template>
	<div id="" ref="">
		<input type="file" ref="idImgFile" style="display:none;" accept=".jpg,.png" @change="onImgChange"/>

		<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:6px; margin-left:10px;" @click="onFileClick">{{getLangText("选择文件")}}</div>
		<div ref="idImgPath" style="float:left; margin-top:7px; text-indent:10px; width:350px; height:30px; line-height:30px; border:0px solid red;"></div>
		<div style="float:left; width:252px; height:252px; margin-top:10px; background:#bbbbbb; border:1px solid #bbbbbb; cursor:pointer;" @click="onFileClick">
			<img ref="idImgPan" style="float:left; border:0px solid red;">
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; margin-top:-1px; margin-left:20px;">{{getLangText('模板名称')}}</div>
			<input type="text" style="width:250px;" maxlength="30" v-model="templaName">
		</div>
		<div style="float:left; width:100%; height:40px; border:0px solid red;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onSaveClick">{{getLangText("保存")}}</div>
		</div>
	</div>
</template>

<script>

import { SuperGif } from "./libgif"

export default {
	name: 'ThumUpd',
	components:{

	},
	data () {
		return {
			prog: 0,
			imgW: 0,   // 图片的原始宽度
			imgH: 0,   // 图片的原始高度
			thumW: 0,  // 缩略图参考宽度
			thumH: 0,  // 缩略图参考高度
			templaName: "",
			base64: "",
		}
	},
	mounted: function(){
		this.templaName = this.$route.query.templaName;
		this.imgW = this.$route.query.width;
		this.imgH = this.$route.query.height;

		let wh=this.getZoomSize(240, 240, this.imgW, this.imgH);     //计算缩放后的规格
		this.thumW = wh[0];
		this.thumH = wh[1];
		this.$refs["idImgPan"].style["width"]  = this.thumW+"px";         //置缩放后的宽度
		this.$refs["idImgPan"].style["height"] = this.thumH+"px";         //置缩放后的高度
		this.$refs["idImgPan"].style["margin-left"] = ((250-this.thumW)/2)+"px";
		this.$refs["idImgPan"].style["margin-top"]  = ((250-this.thumH)/2)+"px";
		this.$refs["idImgPan"].src = this.$route.query.templaIcon;

	},
	computed:{

	},
	methods:{
		onImgChange: function(){
			let file=this.$refs["idImgFile"];
			let image = new Image();
		    let bytes=0;                     //图片的字节数
		    let that=this;
		    image.onload=function(){
		    	that.imgW=image.width;       //图片的原始宽度
		    	that.imgH=image.height;      //图片的原始高度

			    let wh=that.getZoomSize(250, 250, that.imgW, that.imgH);     //计算缩放后的规格

			    that.$refs["idImgPan"].style["width"]  = this.thumW+"px";    //置缩放后的宽度
			    that.$refs["idImgPan"].style["height"] = this.thumH+"px";    //置缩放后的高度
			    that.$refs["idImgPan"].style["margin-left"] = ((250-this.thumW)/2)+"px";
			    that.$refs["idImgPan"].style["margin-top"]  = ((250-this.thumH)/2)+"px";
			    that.$refs["idImgPan"].src = image.src;

			    if( (500 < that.imgW) || (500 < that.imgH) )
			    {
			    	let s="width="+that.imgW+" , height="+that.imgH+"<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;need: width<=500, height<=500";
			    	that.appRoot.app.showDlgCfm( that.DialogType.Err, LangText("提示"), LangText("缩略图规格错误"), s, {okFunc:null, okParam:null} );
			    	return;
			    }
			    that.base64 = image.src;
		    };

			let filePic = file.files[0];
			this.$refs["idImgPath"].innerText = filePic.name;
			if( !filePic ) return;

			bytes = filePic.size;
		    let reader = new FileReader();
		    reader.onload = function (e) {
		        let data = e.target.result;
		        image.src = data;
		    };
		    reader.readAsDataURL(filePic);
		},
		onFileClick: function(){
			this.$refs["idImgFile"].files = null;
			this.$refs["idImgFile"].click();
		},
		/* 保存缩略图和模板名称 */
		onSaveClick: function(){
			let body={};
			body.tmId            = this.$route.query.tmId;
			body.templateId      = this.$route.query.templaId;
			body.templateNameEng = this.templaName;
			if( this.base64 != "" )
			{
				body.templateIcon     = this.base64.split(",")[1];
				body.templateIconFlag = 1;
			}

			this.doTrade( "POST", ServAddr+"/api/template/templateEdit", this.onSaveClickOK, true, body, null );
		},
		onSaveClickOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
			{
				 if( this.$parent.$parent && this.$parent.$parent.$options.name == "TemplaEdit" )
				 {
				 	this.$parent.$parent.templaItem.templateName = this.templaName;
				 	this.$parent.$parent.templaItem.templateIcon = data.body.templateIcon;
				 	this.$parent.$parent.templaItem.iconFlag     = 1;
				 }
				 this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			}
			else this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},

		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// thumupd.vue?599e455a